import React from 'react';

// Configuración de redes sociales - fácil de modificar
const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/lexis.ecuador',
  instagram: 'https://www.instagram.com/lexisecuador/',
  linkedin: 'https://ec.linkedin.com/company/lexis-s-a-ecuador-?original_referer=https%3A%2F%2Fwww.google.com%2F',
  youtube: 'https://www.youtube.com/channel/UCwVAz8vPMFBv3E3taXx0CRw',
  whatsapp: 'https://api.whatsapp.com/send?phone=+593995886995&text=Hola.%20Estoy%20interesado/a%20en%20los%20servicios%20de%20Lexis',
  x: 'https://twitter.com/lexisecuador', // Twitter/X
  email: 'mailto:compras@lexis.com.ec'
};

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white border-t border-gray-800">
      <div className="max-w-7xl mx-auto pt-12 pb-4 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2 lg:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="/logo_lexis_white.svg" 
                alt="Lexis" 
                className="h-8 w-auto"
              />
            </div>
            <p className="text-gray-300 text-sm mb-6 max-w-sm">
              Referente en calidad y precio en búsquedas legales
            </p>
            
            {/* Social Media Links */}
            <div className="mb-6">
              <h4 className="text-white text-sm font-medium mb-4">Síguenos</h4>
              <div className="flex space-x-4">
                <a 
                  href={SOCIAL_LINKS.facebook} 
                  className="text-gray-400 hover:text-primary-500 hover:scale-110 transition-all duration-200"
                  aria-label="Facebook"
                >
                  <img src="/footer/icon_facebook.svg" alt="Facebook" className="h-6 w-6" />
                </a>
                <a 
                  href={SOCIAL_LINKS.x} 
                  className="text-gray-400 hover:text-primary-500 hover:scale-110 transition-all duration-200"
                  aria-label="X (Twitter)"
                >
                  <img src="/footer/icon_x.svg" alt="X" className="h-6 w-6" />
                </a>
                <a 
                  href={SOCIAL_LINKS.linkedin} 
                  className="text-gray-400 hover:text-primary-500 hover:scale-110 transition-all duration-200"
                  aria-label="LinkedIn"
                >
                  <img src="/footer/icon_linkeding.svg" alt="LinkedIn" className="h-6 w-6" />
                </a>
                <a 
                  href={SOCIAL_LINKS.youtube} 
                  className="text-gray-400 hover:text-primary-500 hover:scale-110 transition-all duration-200"
                  aria-label="YouTube"
                >
                  <img src="/footer/icon_youtube.svg" alt="YouTube" className="h-6 w-6" />
                </a>
                <a 
                  href={SOCIAL_LINKS.instagram} 
                  className="text-gray-400 hover:text-primary-500 hover:scale-110 transition-all duration-200"
                  aria-label="Instagram"
                >
                  <img src="/footer/icon_instagram.svg" alt="Instagram" className="h-6 w-6" />
                </a>
              </div>
            </div>

            {/* Contact Section */}
            <div>
              <h4 className="text-white text-sm font-medium mb-4">Escríbenos</h4>
              <div className="flex space-x-4">
                <a 
                  href={SOCIAL_LINKS.whatsapp} 
                  className="text-gray-400 hover:text-green-500 hover:scale-110 transition-all duration-200"
                  aria-label="WhatsApp"
                >
                  <img src="/footer/icon_whatsapp.svg" alt="WhatsApp" className="h-6 w-6" />
                </a>
                <a 
                  href={SOCIAL_LINKS.email} 
                  className="text-gray-400 hover:text-primary-500 hover:scale-110 transition-all duration-200"
                  aria-label="Email"
                >
                  <img src="/footer/icon_email.svg" alt="Email" className="h-6 w-6" />
                </a>
              </div>
            </div>
          </div>

          {/* Navigation Columns */}
          <div className="col-span-1">
            <h4 className="text-white text-sm font-medium mb-4">Home</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-300 hover:text-white text-sm transition-colors">Servicios</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white text-sm transition-colors">Blog</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white text-sm transition-colors">Biblioteca</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white text-sm transition-colors">Contacto</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white text-sm transition-colors">Ayuda</a></li>
            </ul>
          </div>

          <div className="col-span-1">
            <h4 className="text-white text-sm font-medium mb-4">Sobre nosotros</h4>
            <ul className="space-y-3">
              <li><a href="https://www.lexis.com.ec/sobre-nosotros#Testimonios" className="text-gray-300 hover:text-white text-sm transition-colors">Testimonios</a></li>
              <li><a href="https://www.lexis.com.ec/sobre-nosotros/cuidado-al-medio-ambiente" className="text-gray-300 hover:text-white text-sm transition-colors">Cuidado al medio ambiente</a></li>
              <li><a href="https://www.lexis.com.ec/sobre-nosotros/promocion-de-los-derechos-humanos" className="text-gray-300 hover:text-white text-sm transition-colors">Promoción de los Derechos Humanos</a></li>
            </ul>
          </div>

          <div className="col-span-1">
            <h4 className="text-white text-sm font-medium mb-4">Centro de Ayuda</h4>
            <ul className="space-y-3">
              <li><a href="https://www.lexis.com.ec/ayuda" className="text-gray-300 hover:text-white text-sm transition-colors">Compras en línea</a></li>
              <li><a href="https://www.lexis.com.ec/ayuda" className="text-gray-300 hover:text-white text-sm transition-colors">Activación de usuario</a></li>
              <li><a href="https://www.lexis.com.ec/ayuda" className="text-gray-300 hover:text-white text-sm transition-colors">Infolex App</a></li>
            </ul>
          </div>

          <div className="col-span-1">
            {/* App Download Section */}
            <div className="mt-8">
              <h4 className="text-white text-sm font-medium mb-4">INFOLEX APP</h4>
              <p className="text-gray-300 text-xs mb-4">Descarga INFOLEX App en</p>
              <div className="space-y-2 flex gap-2 justify-center items-center">
                <a 
                  href="#" 
                  className="block hover:opacity-80 transition-opacity"
                  aria-label="Descargar en Google Play"
                >
                  <img src="/footer/icon_playstore.svg" alt="Google Play" className="h-10 w-auto" />
                </a>
                <a 
                  href="#" 
                  className="block hover:opacity-80 transition-opacity"
                  aria-label="Descargar en App Store"
                >
                  <img src="/footer/icon_applestore.svg" alt="App Store" className="h-10 w-auto" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className="my-12 pt-8">
          <div className="flex justify-center gap-12 text-center">
            <div>
              <p className="text-white text-sm">
                <span className="font-medium">Quito:</span> 02 241 7309
              </p>
            </div>
            <div>
              <p className="text-white text-sm">
                <span className="font-medium">Guayaquil:</span> 099 940 3353<br />
                099 588 8188
              </p>
            </div>
            <div>
              <p className="text-white text-sm">
                <span className="font-medium">Cuenca:</span> 099 682 1773
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center">
          <p className="text-white text-xs">
            LEXIS S.A. 2025 - Todos los derechos reservados. Los contenidos no pueden reproducirse sin autorización.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
